import { Component, OnInit } from '@angular/core';
import {Subject} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {ApiService} from '../api.service';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';

@Component({
  selector: 'app-validate-code-mdl',
  templateUrl: './validate-code-mdl.component.html',
  styleUrls: ['./validate-code-mdl.component.css']
})
export class ValidateCodeMdlComponent implements OnInit {
  public onClose: Subject<boolean>;
  code;
  myForm: FormGroup;
  user;
  constructor(public bsModalRef: BsModalRef,
              private api: ApiService,
              private toastr: ToastrService,
              public fb: FormBuilder,
              private router: Router) {
    this.myForm = this.fb.group({
      code: ['', [Validators.required, Validators.maxLength(4)]]
    });
  }

  ngOnInit() {
    this.onClose = new Subject();
  }
  public onConfirm(): void {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this.bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this.bsModalRef.hide();
  }

  sendcode(code) {
    console.log(code);
    this.api.validatecode(code, this.user.userId)
      .then(
        (user) => {
          this.toastr.success('Se ha completado el proceso de recuperar contraseña.', 'Notificación');
          this.onConfirm();
        }, error => {
          if (error.status === 404) {
            this.toastr.warning('El código es invalido.', 'Notificación');
          } else {
            this.toastr.error('Ha sucedido un error con el servidor, contacte al administrador.', 'Notificación');
          }
        }
      );
  }

}
